/**
 * HOOK: useDiscounts (VERSION REFACTORISÉE)
 * Utilise le hook useCRUD générique
 *
 * 🎯 Avant: 130 lignes | Après: 22 lignes | Réduction: 83%
 */

import type { Discount, CreateDiscountDto, UpdateDiscountDto } from '../types/discount';
import { useCRUD } from './useCRUD';

export function useDiscounts() {
  const crud = useCRUD<Discount, CreateDiscountDto, UpdateDiscountDto>('discounts', {
    select: '*',
    orderBy: { column: 'name', ascending: true },
  });

  return {
    // API spécifique (pour compatibilité)
    discounts: crud.data,
    loading: crud.loading,
    error: crud.error,
    refreshDiscounts: crud.refresh,
    getDiscountById: crud.getById,
    createDiscount: crud.create,
    updateDiscount: crud.update,
    deleteDiscount: crud.remove,
    deleteDiscounts: crud.removeMany,

    // API générique (pour useEntityList)
    data: crud.data,
    create: crud.create,
    update: crud.update,
    remove: crud.remove,
    removeMany: crud.removeMany,
  };
}

/**
 * MIGRATION GUIDE:
 *
 * ✅ API 100% COMPATIBLE - Aucun changement nécessaire dans les composants !
 *
 * Le hook expose exactement les mêmes méthodes que l'ancienne version:
 * - discounts, loading, error
 * - fetchDiscounts(), createDiscount(), updateDiscount(), deleteDiscount()
 */
